import { Pipe, PipeTransform } from '@angular/core';
/**
  * CountPipe
  *
  * A pipe to return length of array.
  */
@Pipe({ name: 'count' })
export class CountPipe implements PipeTransform {
  /**
  * Accepts array and returns its length
  *
  * @param {any[]} value An array of elements.
  * @return {string} Returns length of passed in array.
  */
  transform(value: any[]): number {
    return value.length;
  }
}
